import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { submitFormData, resetInitialFlow, valueInFormChange } from "./actions";
import TiffNotEligibleForm from "../../Components/TiffNotEligibleForm";
import { TiffFormDerivedStates } from "./selectors";

export const mapStateToProps = state => ({
  ...TiffFormDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  resetInitialFlow: () => dispatch(resetInitialFlow()),
  submitData: data => dispatch(submitFormData(data)),
  valueInFormChange: data => dispatch(valueInFormChange(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TiffNotEligibleForm)
);
